import { isValid } from "date-fns";

export function isValidDate(date: Date | undefined): date is Date {
  return isValid(date);
}
